export function menuToggle() {
	const togglerElement = document.getElementById("main-menu-toggler");
	const menuElement = document.getElementById("main-menu");
	const menuItems = document.querySelectorAll<HTMLElement>("#main-menu a");

	if (!togglerElement || !menuElement) {
		return;
	}

	const clickHandler = function (event: Event) {
		event.preventDefault();

		if (menuElement.classList.contains("show")) {
			menuElement.classList.remove("show");
			togglerElement.classList.remove("menu__toggler--active");
			togglerElement.setAttribute("aria-expanded", "false");
		} else {
			menuElement.classList.add("show");
			togglerElement.classList.add("menu__toggler--active");
			togglerElement.setAttribute("aria-expanded", "true");
		}
	};

	const menuCloseHandler = function () {
		menuElement.classList.remove("show");
		togglerElement.classList.remove("menu__toggler--active");
		togglerElement.setAttribute("aria-expanded", "false");
	};

	togglerElement.addEventListener("click", clickHandler);

	//@ts-ignore
	for (const menuItemElement of menuItems) {
		menuItemElement.addEventListener("click", menuCloseHandler);
	}
}
